import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../Icon/Icon';
import { KeyboardShortcutIndicator } from '../KeyboardShortcutIndicator/KeyboardShortcutIndicator';
import MenuItem from '../Menu/MenuItem';
import { iconClass } from './ClassNames';
import MenuSection from '../Menu/MenuSection';
import { UNIVERSAL_TOGGLE_SEARCH } from '@standardnotes/ui-services';
import { useMemo, useCallback } from 'react';
import { c } from 'ttag';
import { useKeyboardService } from '../KeyboardServiceProvider';
const PlainNoteOptions = ({ closeMenu }) => {
    const keyboardService = useKeyboardService();
    const findShortcut = useMemo(() => keyboardService.keyboardShortcutForCommand(UNIVERSAL_TOGGLE_SEARCH), [keyboardService]);
    const findInNote = useCallback(() => {
        keyboardService.triggerCommand(UNIVERSAL_TOGGLE_SEARCH);
        closeMenu();
    }, [closeMenu, keyboardService]);
    return (_jsx(MenuSection, { children: _jsxs(MenuItem, { onClick: findInNote, children: [_jsx(Icon, { type: "search", className: iconClass }), c('B4.Notes.EditorOptions.Action').t `Find in note`, findShortcut && _jsx(KeyboardShortcutIndicator, { className: "ml-auto", shortcut: findShortcut })] }) }));
};
export default PlainNoteOptions;
